import { useState, useCallback } from 'react';
import api from 'api'; // ton instance axios


export default function useRNE() {
  const [data, setData] = useState(null);
  const [showInfo, setShowInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const checkSiren = useCallback(async (siren) => {
    if (! /^[\d\s]+$/.test(siren)) { // numéro de siren virtuel pour les créations => pas de check
      return null;
    }


    if (!siren) return;

    setLoading(true);
    setError(null);

    try {
      api.handleError = false;
      const response = await api.get(`/rne/siren/${siren}`);

      // attendu :
      // { denomination, adresse_siege }
      if (response.data && response.data?.denomination) {
        setData({ ...response.data, error: false });
        setShowInfo(true)
      } else {
        setData({
          error: true,
          message: 'Le siren indiqué est inconnu du Registre National des&nbsp;Entreprises.'
        });
        setShowInfo(true)
      }
      return response.data;
    } catch (err) {
      setError(err);
      setData(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    rneData: data,
    rneLoading: loading,
    rneError: error,
    checkSiren,
    rneShowInfo: showInfo
  };
}